import { cn } from "@/lib/utils";

import type { ImageStripItem } from "./ImageStripItem";

export const STRIP_HEIGHT_CLASS = "h-[250px]";
export const COVER_SIZE_CLASS = "size-[250px]";
export const PLACEHOLDER_REST_CLASS = "h-[250px] w-[320px]";
export const STRIP_HEIGHT_PX = 250;

export function imageStripFrameClass(isCover: boolean, hasSrc: boolean) {
    return cn(
        "rounded-md",
        STRIP_HEIGHT_CLASS,
        isCover ? COVER_SIZE_CLASS : hasSrc ? "w-auto" : PLACEHOLDER_REST_CLASS,
    );
}

export function imageStripSkeletonBox(
    isCover: boolean,
    width?: number | null,
    height?: number | null,
): { width: number; height: number } {
    if (isCover || !width || !height || width <= 0 || height <= 0) {
        return { width: STRIP_HEIGHT_PX, height: STRIP_HEIGHT_PX };
    }

    return {
        width: Math.round((STRIP_HEIGHT_PX * width) / height),
        height: STRIP_HEIGHT_PX,
    };
}

export function emptyPlaceholderTiles(count: number): ImageStripItem[] {
    return Array.from({ length: count }, (_, index) => ({
        id: `placeholder-${index}`,
    }));
}

export function stripTiles(
    images: readonly ImageStripItem[],
    placeholderCount: number,
): ImageStripItem[] {
    return images.concat(emptyPlaceholderTiles(placeholderCount));
}

export function pendingUploadTiles(count: number): { key: string; isFirst: boolean }[] {
    return Array.from({ length: count }, (_, index) => ({
        key: `pending-upload-${index}`,
        isFirst: index === 0,
    }));
}
